import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { castDraft, immerable, produce } from 'immer';

import dayjs from '../../../core/configs/dayjs';
import { DatablockColumn } from '../../domain/subscription.types';

export interface IDatablockItemEntity {
	id: number;
	label: string;
	columns: Array<DatablockColumn>;
	columnsCount: number;
	updateDate: dayjs.Dayjs | null;
	url: string;
	updatedBy: string;
	updatedByAvatar: AvatarEntity;
}

const entityDefaults: IDatablockItemEntity = {
	id: -1,
	label: '',
	columns: [],
	columnsCount: -1,
	updateDate: null,
	updatedBy: '',
	url: '',
	updatedByAvatar: AvatarEntity.build('user'),
};

export class SubscriptionDatablockItemEntity implements IDatablockItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public columns = entityDefaults.columns;
	public columnsCount = entityDefaults.columnsCount;
	public updateDate = entityDefaults.updateDate;
	public url = entityDefaults.url;
	public updatedBy = entityDefaults.updatedBy;
	public updatedByAvatar = entityDefaults.updatedByAvatar;

	public static build(
		params: Partial<IDatablockItemEntity> = {}
	): SubscriptionDatablockItemEntity {
		const instance = new SubscriptionDatablockItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.columns = params.columns ?? entityDefaults.columns;
		instance.columnsCount = params.columnsCount ?? entityDefaults.columnsCount;
		instance.updateDate = params.updateDate ?? entityDefaults.updateDate;
		instance.url = params.url ?? entityDefaults.url;
		instance.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;

		if (params.updatedBy) {
			instance.updatedByAvatar = AvatarEntity.build(params.updatedBy);
		}

		return instance;
	}

	public setColumns(
		columns: Array<DatablockColumn>
	): SubscriptionDatablockItemEntity {
		return produce(this, (draft) => {
			draft.columns = castDraft(columns);
		});
	}
}
